<div class="col-md-12 mb-30" [hidden]="Form_Swicher_Name!='List'">
  <div class="card card-statistics h-100">
    <div class="card-body">
     <h5 class="card-title border-0 pb-0">About Behfa</h5>
     <br/>
     <br/>
     <div class="row">
      <div  class="form-group col-md-6" >
        <button  type="button" (click)="ReadData_Behfa()" class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
        <button (click)="set_Form_Swicher_Name_For_Text()" type="button"  class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-file-text"></i> Register Text </button>
        <button (click)="set_Form_Swicher_Name_For_Image()" type="button"  class="btn btn-warning" style="margin-right: 5px;"><i class="fa  fa-image"></i> Register Image </button>
        <!--
        <button (click)="set_Form_Swicher_Name_For_Video()" type="button"  class="btn btn-danger" style="margin-right: 5px;"><i class="fa  fa-video-camera"></i> Register Video </button>
        -->
        <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
      </div>
     </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>ID</th>
              <th>Type</th>
              <th>Value</th>
              <th>Creation Date</th>
              <th>Created By</th>
              <th>Modification Date</th>
              <th>Modified By</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Behfa
            |filter:Filter_title:'title'
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_Behfa).length
                      }
            ">
             <td>{{DataList_Behfa.indexOf(item)+1}}</td>
             <td>{{item.id}}</td>
              <td *ngIf="item.type==1">Text</td>
              <td *ngIf="item.type==2">Image</td>
              <td *ngIf="item.type==3">Video</td>

              <td *ngIf="item.type==1">
                (Select Edit to view the text)
              </td>

              <td *ngIf="item.type==2">
                <img (click)="openModalImage(templateImage,this.item.val)"  style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/Behfa/{{this.item.val}}"/>
              </td>

              <td *ngIf="item.type==3">
                {{item.val}}
              </td>

              <td>{{item.create_user}}</td>
              <td>{{item.create_date}} </td>
              <td>{{item.update_user}} </td>
              <td>{{item.update_date}} </td>
              <td>
                <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                  <div *ngIf="!item.deletingProccess" class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Actions
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a *ngIf="item.type==1" style="cursor: pointer;" class="dropdown-item" (click)="set_Form_Swicher_Name_For_Text_Edit(item)"><i class="fa fa-edit"></i> Edit </a>
                        <a *ngIf="item.type==2" style="cursor: pointer;" class="dropdown-item" (click)="set_Form_Swicher_Name_For_Image_Edit(item)"><i class="fa fa-edit"></i> Edit </a>
                        <a *ngIf="item.type==3" style="cursor: pointer;" class="dropdown-item" (click)="set_Form_Swicher_Name_For_Video_Edit(item)"><i class="fa fa-edit"></i> Edit </a>
                        <a *ngIf="item.del==false" style="cursor: pointer;" class="dropdown-item" (click)="openModal(template,item)"><i class="fa fa-remove"></i> Delete </a>
                        <a style="cursor: pointer;" class="dropdown-item" (click)="Priority(item)"><i class="fa fa-arrow-circle-up"></i> Increase Priority </a>
                    </div>
                </div>

                <div *ngIf="item.DeletingProccess" >
                  <img  src="assets/Loading.gif" style="width: 25px;" />
                </div>
              </div>
              </td>

            </tr>
          </tbody>
        </table>
     </div>
    </div>
    <pagination-controls
     id="DataList_FeildTable"
     nextLabel="Next"
     previousLabel="Previous"
     (pageChange)="page = $event"
   ></pagination-controls>
  </div>
</div>

<div class="card card-statistics mb-30" [hidden]="Form_Swicher_Name!='Text'">
  <div class="card-body">
      <h5 class="card-title" *ngIf="selected_Record_Behfa.id==0">Register New About Behfa Text Item </h5>
      <h5 class="card-title" *ngIf="selected_Record_Behfa.id>0">Edit About Behfa Text Item </h5>
      <form  >
          <div class="row">
            <div class="form-group col-md-12">
              <label for="exampleInputEmail1">Text</label>
              <ckeditor name="editorData" [(ngModel)]="model.editorData" [config]="config" [editor]="Editor"></ckeditor>
            </div>
          </div>

          <br/>
          <br/>

          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
          <button *ngIf="!Procssing && selected_Record_Behfa.id==0" type="button" (click)="onSubmitText()"  class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Register Information </button>
          <button *ngIf="!Procssing && selected_Record_Behfa.id>0" type="button" (click)="onSubmitText()"  class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-edit"></i> Edit Information </button>
          <button  *ngIf="!Procssing" (click)="set_Form_Swicher_Name('List')" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> Back </button>
      </form>
  </div>
</div>

<div class="card card-statistics mb-30" [hidden]="Form_Swicher_Name!='Image'">
  <div class="card-body">
      <h5 class="card-title" *ngIf="selected_Record_Behfa.id==0">Register New About Behfa Image Item </h5>
      <h5 class="card-title" *ngIf="selected_Record_Behfa.id>0">Edit About Behfa Image Item </h5>
      <form  >
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">
            Image
            <button (click)="Remove_uploadimage()"  type="button" *ngIf="selected_Record_Behfa.val"  class="btn  btn-danger" ><i class="fa  fa-times-rectangle"></i> </button>
          </label>
          <img *ngIf="InProccessing_image" src="assets/Loading.gif" style="width: 25px;" />
          <input *ngIf="!InProccessing_image" #file_image (change)="uploadimage(file_image.files)" type="file" class="form-control"  placeholder="Type here...">
          <img (click)="openModalImage(templateImage,this.selected_Record_Behfa.val)" *ngIf="selected_Record_Behfa.val" style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/Behfa/{{this.selected_Record_Behfa.val}}"/>
        </div>

        <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        <button *ngIf="!Procssing && selected_Record_Behfa.id==0" type="button" (click)="onSubmitImage()"  class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Register Information </button>
        <button *ngIf="!Procssing && selected_Record_Behfa.id>0" type="button" (click)="onSubmitImage()"  class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-edit"></i> Edit Information </button>
        <button  *ngIf="!Procssing" (click)="set_Form_Swicher_Name('List')" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> Back </button>
      </form>
  </div>
</div>

<div class="card card-statistics mb-30" [hidden]="Form_Swicher_Name!='Video'">
  <div class="card-body">
      <h5 class="card-title" *ngIf="selected_Record_Behfa.id==0">Register New About Behfa Video Item </h5>
      <h5 class="card-title" *ngIf="selected_Record_Behfa.id>0">Edit About Behfa Video Item </h5>
      <form  >
          <div class="row">
            <div class="form-group col-md-12">
              <label for="exampleInputEmail1">Video</label>
              <input [(ngModel)]="VideoLink" name="VideoLink" type="text" class="form-control"  placeholder="Type here...">
            </div>
          </div>

          <br/>
          <br/>

          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
          <button *ngIf="!Procssing && selected_Record_Behfa.id==0" type="button" (click)="onSubmitVideo()"  class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Register Information </button>
          <button *ngIf="!Procssing && selected_Record_Behfa.id>0" type="button" (click)="onSubmitVideo()"  class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-edit"></i> Edit Information </button>
          <button  *ngIf="!Procssing" (click)="set_Form_Swicher_Name('List')" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> Back </button>
      </form>
  </div>
</div>

<ng-template #template>
  <div class="modal-header">
    <h4 *ngIf="Data_Seleted_Delete.del==false"  class="modal-title pull-left">Confirm Deletion of About Behfa Item '{{Data_Seleted_Delete.id}}' </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Delete.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-footer">
    <button *ngIf="Data_Seleted_Delete.del==false"  type="button" class="btn btn-warning" (click)="Delete(Data_Seleted_Delete)"> Delete <i class="fa fa-remove"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Delete.hide()">Close</button>
  </div>
</ng-template>


<ng-template #templateImage>
  <div class="modal-header">
     <h4 class="modal-title pull-left"> View Image </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Image.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-body" style="text-align: center;">
    <img  style="max-width: 350px;" src="{{BaseUrl}}File/Behfa/{{ModalimageUrl}}"/>
  </div>
  <div class="modal-footer">
    <a class="dropdown-item" target="_blank" href="{{BaseUrl}}File/Behfa/{{ModalimageUrl}}"   ><i class="fa fa-download"></i> Download </a>
     <button type="button" class="btn btn-danger" (click)="modalRef_Image.hide()">Close</button>
  </div>
</ng-template>
